module.exports = __webpack_public_path__ + "img/logo.3f06ab50.png";